
import { countiesActionTypes } from '@constants/actionTypes/ssapActionTypes';


export const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case countiesActionTypes.SET_COUNTIES:
            return action.state ?
                {
                    ...state,
                    [action.state]: action.counties
                } :
                {
                    ...state,
                    ...action.counties
                };
        case countiesActionTypes.SET_COUNTY_FOUND_BY_STATE_AND_ZIPCODE:
            return {
                ...state,
                [action.pageName]: action.payload
            };
        case countiesActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
};